// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteButton_deleteButton__hfxmu","deleteIcon":"DeleteButton_deleteIcon__oAmr4","gray":"DeleteButton_gray__i+Bfm"};